import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import SignupContainer from './signup/SignupContainer';
import LoginContainer from './signup/LoginContainer';
import GlobalModalsContainer from './top/GlobalModalsContainer';
import { CustomScrollCss } from '../styled/scroll/CustomScroll';
import ScriptLoader from './common/ScriptLoader';
import { registerServiceWorker } from '../services/serviceWorkerService';
import EventTracker from '../modules/EventTracker';
function LoadingPomo() {
    return (React.createElement("div", { id: "target" },
        React.createElement("div", { className: "spinner__wrapper" },
            React.createElement("img", { className: "spinner__img", src: "/images/icon-white2.png", alt: "icon-white2" }),
            React.createElement("div", { className: "spinner__text" }, "Loading..."))));
}
const TopContainer = lazy(() => import(/* webpackChunkName: "top" */ './top/TopContainer'));
const ResetPasswordContainer = lazy(() => import(
/* webpackChunkName: "reset-password" */ './signup/ResetPasswordContainer').then((module) => ({
    default: module.default,
})));
const GoogleLoginContainer = lazy(() => import(
/* webpackChunkName: "google-login" */ './signup/GoogleLoginContainer').then((module) => ({
    default: module.default,
})));
const AuthTodoistContainer = lazy(() => import(
/* webpackChunkName: "auth" */ './auth/AuthTodoistContainer').then((module) => ({
    default: module.default,
})));
const NewPasswordContainer = lazy(() => import(
/* webpackChunkName: "new-password" */ './signup/NewPasswordContainer').then((module) => ({
    default: module.default,
})));
const BulkContainer = lazy(() => import(/* webpackChunkName: "bulk" */ './bulk/BulkContainer').then((module) => ({
    default: module.default,
})));
function App({ darkMode, stage, bgColor, viewHeight, authenticated, changeBgColor, readIndexedDB, readMongoDB, fetchUser, fetchStripeInfo, 
// fetchRootUrl,
configObj, openModal, isPremium, }) {
    useEffect(() => {
        // Initialize service worker early (lazy initialization will happen automatically)
        registerServiceWorker();
        // unregisterServiceWorker();
        fetchUser();
        fetchStripeInfo();
        // fetchRootUrl();
    }, [null]);
    useEffect(() => {
        changeBgColor(stage, darkMode, configObj.colorThemes);
    }, [stage, darkMode, configObj.colorThemes]);
    useEffect(() => {
        switch (authenticated) {
            case false:
                setTimeout(() => {
                    readIndexedDB();
                }, 500);
                EventTracker.visitApp({ loggedIn: false });
                break;
            case true:
                readMongoDB();
                EventTracker.visitApp({ loggedIn: true });
                break;
            default:
        }
    }, [authenticated]);
    useEffect(() => {
        // if the url contains params of modal, retrieve the value
        const modal = new URL(window.location.href).searchParams.get('modal');
        if (modal) {
            openModal(modal);
            // remove the modal params from url but keep the rest
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, [null]);
    //
    return (React.createElement(BrowserRouter, null,
        React.createElement(ViewPort, { style: { '--bg-color': bgColor }, viewHeight: viewHeight },
            React.createElement(Suspense, { fallback: React.createElement(LoadingPomo, null) },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: "/electron-google-login", component: GoogleLoginContainer }),
                    React.createElement(Route, { path: "/auth-todoist", component: AuthTodoistContainer }),
                    React.createElement(Route, { path: "/signup", component: SignupContainer }),
                    React.createElement(Route, { path: "/login", component: LoginContainer }),
                    React.createElement(Route, { path: "/reset-password", component: ResetPasswordContainer }),
                    React.createElement(Route, { path: "/set-password/:activationKey", component: NewPasswordContainer }),
                    React.createElement(Route, { path: "/bulk", component: BulkContainer }),
                    React.createElement(Route, { path: "/", component: TopContainer }))),
            React.createElement(GlobalModalsContainer, null),
            React.createElement(ScriptLoader, { authenticated: authenticated, isPremium: isPremium }))));
}
export default App;
const ViewPort = styled.div `
  background-color: var(--bg-color);
  min-height: 100vh;
  width: 100%;
  color: white;
  padding-bottom: 12px;
  transition: background-color 0.5s ease-in-out;
  box-sizing: border-box;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);

  ${CustomScrollCss}
`;
